import { GET_DOCUMENT_SEARCH_DATA } from '../../common/actionTypes.js';


const INITIAL_STATE = {
  documentSearchData: [],
  

};

const DocumentSearchReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_DOCUMENT_SEARCH_DATA: {
      return { ...state, documentSearchData: action.payload };
    }
   
    default:
      return state;
  }
};

export default DocumentSearchReducer;
